import React, {Component} from 'react';
import { connect } from 'react-redux';
import gravatar from 'gravatar';
import LoginCard from '../components/LoginCard';
import GoogleSignInButton from '../components/GoogleSignInButton';

@connect(state => ({
    lastUser: state.auth.lastUser,
    loggedOutMessage: state.auth.loggedOutMessage
}))
export default class LoginContainer extends Component {
    render() {
        var {loggedOutMessage, lastUser} = this.props;
        return (
            <Login
                loggedOutMessage={loggedOutMessage}
                lastUser={lastUser} />
        );
    }
}

class Login extends Component {
    render() {
        var {lastUser, loggedOutMessage} = this.props;

        return (
            <LoginCard>
                {loggedOutMessage &&
                    <div className="alert alert-warning"><strong>{loggedOutMessage}</strong></div>
                }

                {lastUser &&
                    <div className="login-user">
                        <img src={gravatar.url(lastUser.email, {s: 150, d: 'retro', r: 'x'}, true)} alt="" />
                        <h2>Welcome back, {lastUser.firstName || lastUser.name}</h2>
                        <p>{lastUser.email}</p>
                    </div>
                }

                <GoogleSignInButton>
                    {lastUser ? 'Continue with Google' : 'Sign in with Google'}
                </GoogleSignInButton>

            </LoginCard>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/Login.js